module.exports = __webpack_public_path__ + "static/media/npnj.f406b20a.png";